<template>
  <div id="paneladmin">
    <!-- <PanelKonfiguracyjny/>
    <Uzytkownicy/> -->
  	<PanelAdminContent/>
  </div>
</template>

<script>
import PanelAdminContent from "@/components/PanelAdminContent";
// import PanelKonfiguracyjny from "./PanelAdministracyjny/PanelKonfiguracyjny.vue";
// import Uzytkownicy from "./PanelAdministracyjny/Uzytkownicy.vue";
import Storage from "./Storage";
export default {
  name: 'PanelAdmin',
  components: {
    // PanelKonfiguracyjny,
    // Uzytkownicy,
	  PanelAdminContent,
  },
  methods: {

  }
}
</script>

<style>
  #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 0px;
  }
  .logoutx {
    padding: 2%;
  }
  #logoutAdmin {
    appearance: button;
    background-color: #c2d0f3;
    border: 1px solid #1652F0;
    border-radius: 4px;
    box-sizing: border-box;
    color: #1652F0;
    cursor: pointer;
    font-family: -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.15;
    overflow: visible;
    padding: 12px 16px;
    position: relative;
    text-align: center;
    width: fit-content;
  }
  .btnAdmin:disabled {
    background-color: #c2d0f3 !important;
    border: 1px solid #c2d0f3; 
    cursor: default;
  }
  .btnAdmin{
    appearance: button;
    background-color: #1652F0;
    border: 1px solid #1652F0;
    border-radius: 4px;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    font-family: -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.15;
    overflow: visible;
    padding: 12px 16px;
    position: relative;
    text-align: center;
    width: fit-content;
  }
</style>



// WEBPACK FOOTER //
// src/components/PanelAdmin.vue